import React from 'react'
import { Flex, Skeleton } from '@chakra-ui/core'

interface PreviewSkeletonProps {
  type?: 'item' | 'chat'
}

export const PreviewSkeleton = ({ type = 'item' }: PreviewSkeletonProps) => {
  const isChat = type === 'chat'

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      mb={isChat ? '18px' : 0}
      pl={isChat ? '15px' : 0}
      pr={isChat ? '18px' : 0}
    >
      <Skeleton height="112px" width="112px" mb={isChat ? '12px' : '7px'} borderRadius="50%" />
      <Skeleton height={isChat ? '12px' : '14px'} width={isChat ? '60px' : '100px'} borderRadius="4px" />
    </Flex>
  )
}

interface PersonalViewSkeletonsProps {
  count?: number
  type?: 'item' | 'chat'
}

export const PersonalViewSkeletons = ({ count = 8, type = 'item' }: PersonalViewSkeletonsProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <PreviewSkeleton key={`skeleton-${type}-${index}`} type={type} />
      ))}
    </>
  )
}
